'use client'

import Image from 'next/image'
import { ScrollToTopButtonProps } from './types'

export function ScrollToTopButton({
  className = '',
  'aria-label': ariaLabel = 'Voltar para o topo',
  ...props
}: ScrollToTopButtonProps) {
  function scrollToTop() {
    const homeSection = document.getElementById('home')

    if (homeSection) {
      homeSection.scrollIntoView({ behavior: 'smooth' })
      return
    }

    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  return (
    <button
      type="button"
      aria-label={ariaLabel}
      className={`flex size-[72px] cursor-pointer items-center justify-center rounded-full bg-white-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-lightning-yellow-600 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-70 ${className}`}
      onClick={scrollToTop}
      {...props}
    >
      <Image
        src="/assets/icons/arrow-line-up.svg"
        alt=""
        width={24}
        height={24}
        aria-hidden="true"
        className="size-6"
      />
    </button>
  )
}
